import type { ExpressionSpecification } from 'mapbox-gl'

// The 42 x 50 assets have seven transparent pixels below the pin tip.
export const pinIconOffset: [number, number] = [0, 7]
export const pinLogicalWidth = 42
export const pinLabelFont = 'Arial Unicode MS Bold'

export const pinLabelTextSize = [
    'case' as const,
    ['<=', ['length', ['get', 'label']], 1],
    16,
    ['==', ['length', ['get', 'label']], 2],
    14,
    ['==', ['length', ['get', 'label']], 3],
    11,
    9,
] satisfies ExpressionSpecification

// Text offsets use em units; keep the label centre 22 pixels above the coordinate.
export const pinLabelTextOffset = [
    'case' as const,
    ['<=', ['length', ['get', 'label']], 1],
    ['literal', [0, -22 / 16]],
    ['==', ['length', ['get', 'label']], 2],
    ['literal', [0, -22 / 14]],
    ['==', ['length', ['get', 'label']], 3],
    ['literal', [0, -22 / 11]],
    ['literal', [0, -22 / 9]],
] satisfies ExpressionSpecification
